import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const SubTitle = styled(Typography, {
  name: 'SubTitle',
  slot: 'Root',
  skipSx: true,
  shouldForwardProp: (prop) => prop !== 'marginTop' && prop != 'marginBottom',
})(
  ({ marginLeft, marginRight, marginBottom, marginTop }) =>
    `
  font-family: Source Sans Pro;
  font-size: 14px;  
  line-height: 20px;
  margin-bottom: ${marginBottom ? `${marginBottom}` : '12px'};
  margin-top: ${marginTop ? `${marginTop}` : '8px'};
  margin-left: ${marginLeft ? `${marginLeft}` : '12px'};
  margin-right: ${marginRight ? `${marginRight}` : '0px'};
`,
)
